var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoolPond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    x: 0,
    y: 0,
    viewBox: "0 0 682.667 682.667",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0s-4.687 101.416 45.025 165.979c3.852 5.002-1.817 11.724-7.397 8.772C11.271 160.81-30.924 120.314-41.628 3.059Z",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(432.66 250.203)",
    fill: "#1ca56f",
    "data-original": "#1ca56f",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s-4.687 101.416 45.025 165.979c3.852 5.002-1.817 11.724-7.397 8.772C11.271 160.81-30.924 120.314-41.628 3.059Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(432.66 250.203)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s4.06 87.825-38.3 145.356c-3.787 5.144 2.196 11.772 7.706 8.541C-7.06 140.099 27.901 102.876 37.044 2.722Z",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(180.832 201.214)",
    fill: "#1ca56f",
    "data-original": "#1ca56f",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s4.06 87.825-38.3 145.356c-3.787 5.144 2.196 11.772 7.706 8.541C-7.06 140.099 27.901 102.876 37.044 2.722Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(180.832 201.214)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s3.469 87.492-25.123 174.969",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(208.866 242.473)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-10.036 0-18.646 7.596-19.694 17.797-2.764 26.895-7.365 52.606-13.672 76.418-2.804 10.583 3.503 21.434 14.085 24.238 10.588 2.804 21.433-3.503 24.236-14.085 6.837-25.807 11.813-53.571 14.787-82.518C20.861 10.96 12.94 1.225 2.051.105A20.3 20.3 0 0 0 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(208.092 289.381)",
    fill: "#fcb44d",
    "data-original": "#fcb44d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a20.25 20.25 0 0 0-2.05-.11c-1.72 0-3.4.22-5 .65C-2.779 4.63-.38 10.57-1.029 16.9c-2.981 28.95-7.95 56.71-14.79 82.52-1.891 7.15-7.46 12.34-14.131 14.1a19.783 19.783 0 0 0 8.621 4.83c10.59 2.8 21.43-3.51 24.239-14.09 6.83-25.81 11.811-53.57 14.78-82.52C18.811 10.85 10.891 1.12 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(210.14 289.487)",
    fill: "#fb9927",
    "data-original": "#fb9927"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-10.036 0-18.646 7.596-19.694 17.797-2.764 26.895-7.365 52.606-13.672 76.418-2.804 10.583 3.503 21.434 14.085 24.238 10.588 2.804 21.433-3.503 24.236-14.085 6.837-25.807 11.813-53.571 14.787-82.518C20.861 10.96 12.94 1.225 2.051.105A20.3 20.3 0 0 0 0 0Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(208.092 289.381)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s-3.989 86.324 38.325 141.28c3.279 4.258-1.547 9.979-6.297 7.467C9.595 136.88-26.321 102.411-35.433 2.604Z",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(98.53 216.56)",
    fill: "#1ca56f",
    "data-original": "#1ca56f",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s-3.989 86.324 38.325 141.28c3.279 4.258-1.547 9.979-6.297 7.467C9.595 136.88-26.321 102.411-35.433 2.604Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(98.53 216.56)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s3.99 86.324-38.325 141.28c-3.278 4.258 1.548 9.979 6.297 7.467 22.434-11.867 58.35-46.336 67.462-146.143Z",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(65.209 216.56)",
    fill: "#a3e440",
    "data-original": "#a3e440",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s3.99 86.324-38.325 141.28c-3.278 4.258 1.548 9.979 6.297 7.467 22.434-11.867 58.35-46.336 67.462-146.143Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(65.209 216.56)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s3.456 74.756-32.601 123.725c-3.223 4.379 1.87 10.021 6.56 7.271 20.032-11.745 49.79-43.429 57.572-128.679Z",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(41.61 202.225)",
    fill: "#1ca56f",
    "data-original": "#1ca56f",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s3.456 74.756-32.601 123.725c-3.223 4.379 1.87 10.021 6.56 7.271 20.032-11.745 49.79-43.429 57.572-128.679Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(41.61 202.225)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s-3.99 86.324 38.325 141.28c3.279 4.257-1.547 9.979-6.297 7.467C9.594 136.88-26.322 102.41-35.433 2.604Z",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(444.748 217.321)",
    fill: "#a3e440",
    "data-original": "#a3e440",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s-3.99 86.324 38.325 141.28c3.279 4.257-1.547 9.979-6.297 7.467C9.594 136.88-26.322 102.41-35.433 2.604Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(444.748 217.321)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s-3.455 74.756 32.601 123.726c3.223 4.378-1.869 10.02-6.56 7.27C6.01 119.251-23.749 87.567-31.531 2.317Z",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(468.347 202.986)",
    fill: "#1ca56f",
    "data-original": "#1ca56f",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s-3.455 74.756 32.601 123.726c3.223 4.378-1.869 10.02-6.56 7.27C6.01 119.251-23.749 87.567-31.531 2.317Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(468.347 202.986)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s-4.687 101.416 45.025 165.979c3.851 5.002-1.818 11.724-7.397 8.772C11.271 160.81-30.924 120.314-41.628 3.059Z",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(236.472 244.234)",
    fill: "#a3e440",
    "data-original": "#a3e440",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s-4.687 101.416 45.025 165.979c3.851 5.002-1.818 11.724-7.397 8.772C11.271 160.81-30.924 120.314-41.628 3.059Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(236.472 244.234)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s-4.06 87.826 38.301 145.356c3.787 5.144-2.197 11.773-7.707 8.541C7.061 140.099-27.9 102.877-37.044 2.722Z",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(264.195 227.393)",
    fill: "#1ca56f",
    "data-original": "#1ca56f",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s-4.06 87.826 38.301 145.356c3.787 5.144-2.197 11.773-7.707 8.541C7.061 140.099-27.9 102.877-37.044 2.722Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(264.195 227.393)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 32.255-111.257 58.403-248.5 58.403S-497 32.255-497 0c0-17.811 33.928-33.757 87.419-44.469 18.154-3.635 35.115-12.165 48.151-25.312 22.336-22.529 81.772-38.64 151.592-38.64 88.952 0 161.062 26.148 161.062 58.403l-.001.143c-.058 8.716 5.061 16.58 13.183 19.742C-13.001-21.335 0-11.025 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(504.5 194.745)",
    fill: "#64b9fc",
    "data-original": "#64b9fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-5.249 16.811-9.503 37.548-9.503 20.738 0 37.549 4.254 37.549 9.503 0 5.249-16.811 9.503-37.549 9.503C16.811 9.503 0 5.249 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(215.174 129.195)",
    fill: "#31a7fb",
    "data-original": "#31a7fb",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-5.249-16.811-9.503-37.549-9.503-20.737 0-37.548 4.254-37.548 9.503 0 5.248 16.811 9.503 37.548 9.503C-16.811 9.503 0 5.248 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(187.61 185.708)",
    fill: "#31a7fb",
    "data-original": "#31a7fb",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-11.03-13-21.34-35.59-30.14-8.13-3.16-13.25-11.02-13.19-19.74v-.14c0-30.37-63.909-55.32-145.62-58.13 59.38 10.47 100.67 33.68 100.67 60.63v.16c-.06 9.94 5.4 18.9 14.05 22.51C-55.59-14.82-41.73-3.07-41.73 9.5c0 11.71-12.03 22.72-33.17 32.28C-28.689 31.18 0 16.38 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(504.5 194.747)",
    fill: "#31a7fb",
    "data-original": "#31a7fb",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c30.992 10.644 50.328 25.707 50.328 42.408v.143c-.058 8.716 5.063 16.579 13.184 19.742 22.592 8.797 35.593 19.108 35.593 30.133 0 32.255-111.257 58.403-248.5 58.403s-248.5-26.148-248.5-58.403c0-17.811 33.928-33.758 87.419-44.469 18.155-3.636 35.116-12.165 48.152-25.312 22.336-22.529 81.771-38.64 151.592-38.64 28.787 0 55.803 2.741 79.189 7.539",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(405.394 102.319)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s3.933 99.202-28.484 198.385",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(149.912 192.048)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-8.86 0-16.461 6.706-17.387 15.712-2.44 23.745-6.502 46.444-12.07 67.467-2.476 9.342 3.092 18.923 12.435 21.398 9.347 2.476 18.922-3.093 21.397-12.435 6.036-22.785 10.429-47.295 13.055-72.851.988-9.615-6.005-18.21-15.619-19.198A17.862 17.862 0 0 0 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(142.923 277.375)",
    fill: "#ffd496",
    "data-original": "#ffd496",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.601-.06-1.211-.09-1.811-.09-2.359 0-4.639.48-6.719 1.35 4.04 3.61 6.36 9.04 5.759 14.85C-5.4 41.66-9.791 66.17-15.83 88.96c-1.441 5.47-5.33 9.64-10.17 11.67a17.347 17.347 0 0 0 7.17 3.85c9.35 2.48 18.92-3.09 21.399-12.43C8.6 69.27 13 44.75 15.619 19.2 16.609 9.58 9.619.99 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(144.73 277.467)",
    fill: "#fcc16d",
    "data-original": "#fcc16d",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-8.86 0-16.461 6.706-17.387 15.712-2.44 23.745-6.502 46.444-12.07 67.467-2.476 9.342 3.092 18.923 12.435 21.398 9.347 2.476 18.922-3.093 21.397-12.435 6.036-22.785 10.429-47.295 13.055-72.851.988-9.615-6.005-18.21-15.619-19.198A17.862 17.862 0 0 0 0 0Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(142.923 277.375)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c2 26.836 10.458 107.507 43.129 186.294",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(252.964 134.855)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c8.834-.683 16.929 5.417 18.547 14.325 4.265 23.485 10.064 45.803 17.237 66.334 3.189 9.124-1.623 19.105-10.747 22.294-9.129 3.189-19.105-1.624-22.293-10.748-7.775-22.251-14.045-46.35-18.634-71.628C-17.617 11.068-11.308 1.959-1.798.233A17.73 17.73 0 0 1 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(265.941 210.084)",
    fill: "#ffd496",
    "data-original": "#ffd496",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-7.181-20.53-12.98-42.85-17.24-66.34-1.62-8.91-9.71-15.01-18.551-14.32a17.488 17.488 0 0 0-11.17 5.19c6.101 1.83 10.981 6.94 12.2 13.64C-30.5-38.34-24.7-16.02-17.53 4.51c2.269 6.5.489 13.43-4.021 18.03 3.42 1.02 7.17 1.02 10.801-.25C-1.631 19.1 3.18 9.12 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(301.73 290.747)",
    fill: "#fcc16d",
    "data-original": "#fcc16d",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c8.834-.683 16.929 5.417 18.547 14.325 4.265 23.485 10.064 45.803 17.237 66.334 3.189 9.124-1.623 19.105-10.747 22.294-9.129 3.189-19.105-1.624-22.293-10.748-7.775-22.251-14.045-46.35-18.634-71.628C-17.617 11.068-11.308 1.959-1.798.233A17.73 17.73 0 0 1 0 0Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(265.941 210.084)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-5.249-16.811-9.503-37.549-9.503-20.737 0-37.548 4.254-37.548 9.503 0 5.248 16.811 9.503 37.548 9.503C-16.811 9.503 0 5.248 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(371.19 203.64)",
    fill: "#31a7fb",
    "data-original": "#31a7fb",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s-4.372 102.55 56.537 189.422",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(333.71 206.369)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-1.544 0-3.112.206-4.673.637-9.315 2.575-14.779 12.215-12.204 21.53 7.991 28.907 19.232 55.809 33.409 79.958 4.893 8.335 15.616 11.125 23.952 6.231 8.334-4.893 11.124-15.616 6.232-23.951-12.634-21.519-22.68-45.596-29.859-71.564C14.714 5.086 7.674 0 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(346.571 283.76)",
    fill: "#fcb44d",
    "data-original": "#fcb44d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-12.64-21.52-22.681-45.6-29.86-71.57-2.14-7.75-9.18-12.84-16.86-12.84-1.54 0-3.11.21-4.67.64a17.454 17.454 0 0 0-9.07 6.02c5.9 1.49 10.85 6.03 12.58 12.31C-40.7-39.48-30.66-15.4-18.021 6.12c3.761 6.4 2.981 14.21-1.359 19.7 4.3 1.09 9.02.55 13.151-1.87C2.101 19.06 4.89 8.33 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(393.29 368.167)",
    fill: "#fb9927",
    "data-original": "#fb9927"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a356.54 356.54 0 0 1-9.395-29.078c-2.576-9.315 2.889-18.955 12.204-21.53a17.481 17.481 0 0 1 4.673-.637c7.674 0 14.713 5.086 16.858 12.841 7.178 25.967 17.224 50.045 29.857 71.564 4.893 8.335 2.104 19.058-6.23 23.951-8.336 4.894-19.061 2.104-23.953-6.231a308.919 308.919 0 0 1-11.149-20.814",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(339.09 335.005)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-5.249-16.811-9.503-37.549-9.503-20.737 0-37.548 4.254-37.548 9.503 0 5.248 16.811 9.503 37.548 9.503C-16.811 9.503 0 5.248 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(449.27 153.785)",
    fill: "#31a7fb",
    "data-original": "#31a7fb",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-2 26.836-10.458 107.507-43.129 186.294",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(413.278 154.645)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-8.834-.683-16.93 5.417-18.547 14.325-4.265 23.485-10.064 45.803-17.237 66.334-3.19 9.124 1.623 19.105 10.747 22.294 9.129 3.189 19.104-1.624 22.293-10.748 7.775-22.251 14.045-46.35 18.634-71.627C17.616 11.068 11.308 1.959 1.798.233A17.73 17.73 0 0 0 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(400.3 229.875)",
    fill: "#ffd496",
    "data-original": "#ffd496",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.6-.11-1.199-.19-1.8-.23-1.909-.15-3.79.02-5.58.47 4.441 3.92 6.78 10 5.64 16.25-4.59 25.28-10.86 49.38-18.629 71.63a17.487 17.487 0 0 1-12.28 11.2 17.344 17.344 0 0 0 5.809 3.4c9.131 3.19 19.111-1.62 22.301-10.75C3.23 69.72 9.5 45.62 14.09 20.35 15.82 10.84 9.51 1.73 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(402.1 230.107)",
    fill: "#fcc16d",
    "data-original": "#fcc16d",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-8.834-.683-16.93 5.417-18.547 14.325-4.265 23.485-10.064 45.803-17.237 66.334-3.19 9.124 1.623 19.105 10.747 22.294 9.129 3.189 19.104-1.624 22.293-10.748 7.775-22.251 14.045-46.35 18.634-71.627C17.616 11.068 11.308 1.959 1.798.233A17.73 17.73 0 0 0 0 0Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(400.3 229.875)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h8.816",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(96.234 210.032)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h8.816",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(204.59 176.205)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h8.816",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(291.685 120.012)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h8.816",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(68.733 192.048)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h8.816",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(324.65 169.736)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24.027",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(193.787 206.369)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h23.798",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(351.8 149.098)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-50.725c-5.731 0-10.378 4.646-10.378 10.377v59.608c0 19.739 16.002 35.74 35.741 35.74 19.738 0 35.739-16.001 35.739-35.74V10.377C10.377 4.646 5.731 0 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(177.233 86.324)",
    fill: "#96756f",
    "data-original": "#96756f",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-59.61c0-5.73-4.65-10.37-10.38-10.37h-22.36c5.729 0 10.38 4.64 10.38 10.37V0c0 9.87-4 18.8-10.47 25.27-3.9 3.91-8.71 6.92-14.091 8.68a35.586 35.586 0 0 0 11.181 1.79c9.87 0 18.809-4 25.269-10.47C-4 18.8 0 9.87 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(187.61 156.307)",
    fill: "#80635e",
    "data-original": "#80635e",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v7.448c0 19.738-16.001 35.739-35.739 35.739-19.739 0-35.74-16.001-35.74-35.739V-52.16c0-5.732 4.646-10.378 10.377-10.378h50.725C-4.646-62.538 0-57.892 0-52.16v19.499",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(187.61 148.861)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-50.726c-5.73 0-10.377 4.646-10.377 10.377v22.25c0 19.738 16.001 35.74 35.74 35.74h.001c19.738 0 35.739-16.002 35.739-35.74v-22.25C10.377 4.646 5.73 0 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(129.926 86.324)",
    fill: "#d6a59d",
    "data-original": "#d6a59d",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-22.25c0-5.73-4.64-10.37-10.37-10.37h-21.54c5.73 0 10.38 4.64 10.38 10.37V0c0 9.87-4 18.8-10.47 25.27-4 4.01-8.96 7.07-14.5 8.82 3.4 1.07 7.011 1.65 10.761 1.65 9.869 0 18.8-4 25.269-10.47C-4 18.8 0 9.87 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(140.3 118.947)",
    fill: "#ac8380",
    "data-original": "#ac8380",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-50.726c-5.73 0-10.377 4.646-10.377 10.377v22.25c0 19.738 16.001 35.74 35.74 35.74h.001c19.738 0 35.739-16.002 35.739-35.74v-22.25C10.377 4.646 5.73 0 0 0Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(129.926 86.324)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-7.354",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(159.023 158.702)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v34.183",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(115.652 86.324)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-8.154",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(92.786 120.507)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoolPond);
export default __webpack_public_path__ + "static/media/poolPond.f6e5f070d44ce094f4a5083e558f7bf1.svg";
export { ForwardRef as ReactComponent };